import { initializeForm } from '../utils/form';
import { validateNotEmpty, validateBranchCode, validateSortCode, validateAccountNumber } from '../utils/validators';

export const refundFormInitialisation = (
    userBankDetailsCountrySelect,
    USER_BANK_DETAILS_FORM_PER_COUNTRY,
    countryOfAuction,
    currentCountryName,
    preventDefault,
  ) => {
    const countrySelectInput = userBankDetailsCountrySelect.find(
      '.select-field__input'
    );
    const countryNameInput = $('input[name="country"]:not(".select-field__input")');

    const FIELDS_PER_COUNTRY = {
      ireland: ['iban', 'bic', 'account_name'],
      cyprus: ['iban', 'bic', 'account_name'],
      'south africa': ['bank_name', 'account_name', 'iban', 'bic'],
      spain: ['iban', 'account_name'],
      'united kingdom': ['bic', 'account_name', 'iban'],
    };

    let currentCountryFormInstance;
    let currentCountryFormName;
    let currentCountryFormElement;

    const initializeFormForCountry = (countryName, countryFormElement) => {
      const name = countryName.toLowerCase();
      const fieldsToBeValidated = FIELDS_PER_COUNTRY[name];
      const bankTransferUserDetailsSubmitButton = countryFormElement.find(
        'button[name="submit-refund-button"]'
      );
      return initializeForm(countryFormElement, {
        preventDefault: preventDefault,
        validate: (values) => {
          let errors = {
            ...validateNotEmpty(values, fieldsToBeValidated),
          };
          if(name === 'united kingdom'){
            errors = {...errors, ...validateSortCode(values, ['bic']), ...validateAccountNumber(values, ['iban'])};
          }

          if(name === 'south africa'){
            errors = {...errors, ...validateBranchCode(values, ['bic']), ...validateAccountNumber(values, ['iban'])};
          }

          const hasErrors = !$.isEmptyObject(errors);
          bankTransferUserDetailsSubmitButton.attr('disabled', hasErrors);
          return errors;
        },
      });
    };

    const determineCountryFormForCountry = (countryName) => {
      // check if country has it own form
      if (USER_BANK_DETAILS_FORM_PER_COUNTRY.hasOwnProperty(countryName)) {
        return countryName;
      } else if (
        // if selected country doesn't have it's own form then check if auction's country has a form
        USER_BANK_DETAILS_FORM_PER_COUNTRY.hasOwnProperty(countryOfAuction)
      ) {
        return countryOfAuction;
      } else {
        // by default return ireland form
        return 'ireland';
      }
    };

    const onCountryChange = (countryName) => {
      // hide current form
      currentCountryFormElement.hide();

      // reset current form instance and html inputs
      currentCountryFormElement
        .find("input:not([name='submit'], [type='hidden'])")
        .val('')
        .trigger('change');
      currentCountryFormInstance.restart();

      // determine country form
      const countryForm = determineCountryFormForCountry(countryName);
      currentCountryFormElement = USER_BANK_DETAILS_FORM_PER_COUNTRY[countryForm];

      // initialize new form
      currentCountryFormInstance = initializeFormForCountry(
        countryForm,
        currentCountryFormElement
      );

      // show new form
      currentCountryFormElement.show();
      currentCountryName = countryName;
    };

    // determine country form and initialize it
    currentCountryFormName = determineCountryFormForCountry(
      currentCountryName
    );
    currentCountryFormElement =
      USER_BANK_DETAILS_FORM_PER_COUNTRY[currentCountryFormName];
    currentCountryFormInstance = initializeFormForCountry(
      currentCountryFormName,
      currentCountryFormElement
    );

    const setCountryToBePost = (value) => {
      countryNameInput.val(value).trigger('change');
    }

    // adds listener on country change
    countrySelectInput.on('change', ($event) => {
      const { value } = $event.target;
      const countryName = value.toLowerCase();
      if (currentCountryName !== countryName) {
        onCountryChange(countryName);
        setCountryToBePost(value);
      }
    });
  }